





































import {
  Vue,
  Component,
  Inject,
  Prop,
  Watch
} from "@/shared/vuepack";
import Input from "@/shared/components/ui/Input.vue";
import { Validator } from "vee-validate";
import * as _ from "lodash";

const digitPattern = /\d/g;
const extSplitPattern = /x/i;

function toDigitArray (str: string): string[] {
    const accumulator: string[] = [];

    for (let match = digitPattern.exec(str); match; match = digitPattern.exec(str)) {
      accumulator.push(match[0]);
    }

    return accumulator;
}

@Component({
  components: {
    Input
  }
})
export default class EmployerPhone extends Vue {
  @Inject() $validator: Validator;

  @Prop({ type: String, required: true })
  id: string;

  @Prop({ type: String, required: true })
  label: string;

  @Prop({ type: String, required: false })
  name: string;

  @Prop({ type: String, required: false })
  value: string;

  @Prop({ type: Boolean, required: false })
  disabled: boolean;

  @Prop({ type: Boolean, required: false, default: true })
  required: boolean;

  extension = "";
  formattedNumber = "";

  forceValidation = true;

  get extensionId () { return this.id  + "-extension"; }
  get extensionDisabled () { return this.disabled || !this.formattedNumber; }
  get validationName () { return this.name || "company phone"; }

  get veeValidate () {
    return {
      required: this.required,
      phone: true
    };
  }

  @Watch("value")
  onValueChange (newValue) {
    this.extension = "";
    this.formattedNumber = "";

    if (!newValue) {
      return;
    }

    if (newValue[0] === "+" && newValue.length === 12) {
      newValue = newValue.substring(2, 12);
    }

    const split = newValue.split(extSplitPattern);
    if (!split || !split.length) {
      return;
    }


    let rawExt = "";
    if (split.length >= 2) {
      rawExt = split[1];
    }

    const coll = _.take(toDigitArray(split[0]), 10);
    const ext = _.take(toDigitArray(rawExt), 8);

    if (ext.length) {
      ext.splice(0, 0, "x");
    }

    if (coll.length > 3) {
      coll.splice(3, 0, "-");
    }

    if (coll.length > 7) {
      coll.splice(7, 0, "-");
    }

    this.extension = ext.join("");
    this.formattedNumber = coll.join("");

    if (!this.formattedNumber) {
      this.extension = "";
    }
  }

  mounted () {
    this.forceValidation = false;
    this.onValueChange(this.value);
    this.forceValidation = true;
  }

  onExtensionInput (extension: string) {
    if (!extension) {
      extension = "";
    }

    const extPieces = extension.split(extSplitPattern);
    extension = _.last(extPieces);

    if (extension) {
      extension = "x" + extension;
    }

    this.$emit("input", this.formattedNumber + extension);
  }

  onNumberInput (newNumber: string) {
    this.$emit("input", newNumber + this.extension);
  }
}
